var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bsp-tabs',{attrs:{"tabList":_vm.tabList,"tabIndex":_vm.tabIndex},on:{"changeTab":_vm.changeTab}},[_c(_vm.currentTab,{tag:"component",attrs:{"currentTab":_vm.currentTab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }